import {
  CreateProcurementListPageHeader,
  CreateProcurementListTable,
} from "./components";

export default function CreateProcurementList() {
  return (
    <div className="d-grid gap-10 p-10">
      <CreateProcurementListPageHeader />
      <CreateProcurementListTable />
    </div>
  );
}
